export default __webpack_public_path__ + "static/media/pictogramMedicare64.9d5a9178.svg";